import React from 'react';
import styles from './NotFound.module.scss';
import noSafariImg from '../../images/no-safaris-icon.svg';

const NotFoundPage = () => (
  <div className={styles.outer}>
    <div className={styles.inner}>
      <img src={noSafariImg} alt="desert" className={styles.img} />
      <div className={styles.textContainer}>
      <h2 className={styles.header}>404</h2>
      <h2 className={styles.subheader}>Page not found</h2>
      <p className={styles.text}>The page you have requested does not exist or has been moved.</p>
      </div>
    </div>
  </div>
)

export default NotFoundPage
